module.exports = __webpack_public_path__ + "static/img/Application_Interaction_Example2.eb128d5e.png";